import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { BugsnagEventLogger, EventLogger } from '../models/Logging';
import { polyfillAsync } from '../models/UiUtils';
import { AppHashHistory } from './constants/hash-history';
import { App } from './containers/App';
import AppRouter from './containers/AppRouter';
import './styles/main.less';

const bugsnagEventLogger = new BugsnagEventLogger(import.meta.env.MODE);
const ErrorBoundary = bugsnagEventLogger.getErrorBoundary();
EventLogger.addLogger(bugsnagEventLogger);

document.addEventListener('DOMContentLoaded', async () => {
	await polyfillAsync();
	if (!import.meta.env.PROD && import.meta.env.VITE_MOCKS === 'true') {
		const { worker } = await import('../mocks');
		await worker.start();
	}
	configure({ enforceActions: 'never' });
	const root = createRoot(document.getElementById('react-root'));
	root.render(
		<ErrorBoundary>
			<App>
				<AppRouter history={AppHashHistory} />
			</App>
		</ErrorBoundary>
	);
});
